import { renderRoot } from 'quartz-core/client';
import { DataFetchingClient, DataFetchingClientProvider } from 'data-fetching-client';
import UIApplication from 'UIComponents/app/UIApplication';
import { createBrowserHistory } from 'history';
import { getQueryString, goToUrl } from './utils/navigationUtils';

// I18n
import lang from 'i2l?query=sporks!../lang/en.lyaml';
import BasicI18nSetup from 'I18n/init/setup/BasicI18nSetup';
import BasicPublicI18nSetup from 'I18n/init/setup/BasicPublicI18nSetup';

// Rhumb
import { RhumbProvider } from 'react-rhumb';
import rhumbConfig from '../rhumb-config.yaml';
import historyAdapter from 'react-rhumb/historyAdapterV4';

// Redux
import { Provider } from 'react-redux';
import configureStore from './utils/configureStore';
import { getAuthData } from './utils/authUtils';
import auth from './utils/Auth';

// Configure the router
import { Router } from 'react-router-dom';
import { getOauthBridgeUrl, ROOT_URL_AUTH, ROOT_URL_NO_AUTH } from './utils/urls';
import Routes from './components/Routes';
import { jsx as _jsx } from "react/jsx-runtime";
const client = new DataFetchingClient();
export default class App {
  start({
    hubless
  }) {
    return auth.init({
      hubless
    }).then(authResult => {
      const I18nSetup = hubless ? BasicPublicI18nSetup.setup({
        lang
      }) : BasicI18nSetup.setup({
        lang,
        user: authResult.user || {
          langEnabled: false
        },
        portal: authResult.portal || {}
      });
      return I18nSetup.then(() => this.startReduxAndRouter({
        withAuth: !hubless
      }));
    }).catch(() => {
      return this.redirectToOauthBridge();
    });
  }
  startReduxAndRouter({
    withAuth
  }) {
    const authData = getAuthData();
    const basename = withAuth ? ROOT_URL_AUTH : ROOT_URL_NO_AUTH;
    this.store = configureStore({
      auth: Object.assign({}, authData, {
        withAuth
      })
    });
    const history = createBrowserHistory({
      basename
    });
    renderRoot( /*#__PURE__*/_jsx(UIApplication, {
      name: "oauth-ui",
      children: /*#__PURE__*/_jsx(DataFetchingClientProvider, {
        client: client,
        children: /*#__PURE__*/_jsx(Provider, {
          store: this.store,
          children: /*#__PURE__*/_jsx(RhumbProvider, {
            config: rhumbConfig,
            history: historyAdapter(history),
            children: /*#__PURE__*/_jsx(Router, {
              history: history,
              children: /*#__PURE__*/_jsx(Routes, {})
            })
          })
        })
      })
    }));
  }
  redirectToOauthBridge() {
    goToUrl(`${getOauthBridgeUrl(getQueryString())}`);
  }
}